import {
    useState } from "react";
import {
  VERIFY_USER_CREDENTIALS,
  detectBrowser,
  getOperatingSystem,
  SUCCESS,
  ACCESSDENIED,
  FAILED,
  setLoginResponse,
  VALIDITYEXPIREDERR,
  isEmpty,
  setUrl,
  printDebugLog
} from "../../constants/constant";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setCartType, setApiUrl, setBaseProductData, setBaseCateogoryData, setActiveShopHashFromLogin } from "../../actions";
import { userGestureInitAudio } from "../Chatengine/context/ShareAudio";

const useForm = (baseUrl, callback, validate, setLoader) => {
  const dispatch = useDispatch();

  const [values, setValues] = useState({
    useremail: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [errResponse, setErrResponse] = useState({
    error: false,
    errMsg: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    //printDebugLog("handleInputChange",e.target.value);
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleEnableSound();
    setErrors(validate(values));
    if (Object.keys(errors).length === 0) {
      verifyCredentials();
    }
    // setIsSubmit(true);
  };

  const handleEnableSound = () => {
    userGestureInitAudio().catch((err) =>
      console.warn("Could not unlock audio:", err)
    );
  };

  const verifyCredentials = async () => {
    setLoader(true);
    const data = {
      userEmail: values.useremail,
      userPassWord: values.password,
      apiToken: "",
      deviceName: getOperatingSystem() + "," + detectBrowser(),
    };
    //  console.log("sending... " , data);
    axios.post(
      baseUrl + VERIFY_USER_CREDENTIALS,
      data
    )
      .then((response) => {
        //console.log("login data... ", response.data);
        setLoader(false);
        if (response.data.errCode === SUCCESS) {
          setLoginResponse(response.data);
          dispatch(setCartType(response.data.cartType))
          dispatch(setActiveShopHashFromLogin(response.data.activeShopHash))
          if (!isEmpty(response.data.ip)) {
            const baseUrl = setUrl(response.data.ip);
            setApiUrl(baseUrl);
            console.log("setApiUrl: after login", baseUrl);
          }
          const worker = new Worker(new URL('../billing/GetDataFromDbWorker.js', import.meta.url));
          worker.postMessage(response.data.activeShopHash.id);
          worker.postMessage("fullData");
          worker.onmessage = (e) => {
            let savedData = e.data;
            printDebugLog("GetDataFromDbWorker login", savedData);
            if (savedData !== undefined && savedData.data !== undefined) {
              if ("fullData" === savedData.type) {
                const dataMap = Object.fromEntries(savedData.data
                  .filter(item => item.id !== response.data.activeShopHash.id)
                  .map(item => [item.id, item.value]));
                printDebugLog("dataMap login", dataMap)
                dispatch(setBaseProductData(dataMap));
              } else {
                dispatch(setBaseCateogoryData(savedData.data.value));
              }
            }
          };
          callback();
          console.log("Login Successfull");
        } else if (response.data.errCode === ACCESSDENIED) {
          setErrResponse({
            error: true,
            errMsg: "Sorry! This Feature is Inactive for you ! Contact the SNP",
          });
        } else if (response.data.errCode === FAILED) {
          setErrResponse({
            error: true,
            errMsg: "UserName and Password is wrong",
          });
        } else if (response.data.errCode === VALIDITYEXPIREDERR) {
          setErrResponse({
            error: true,
            errMsg: "Your Validity is Expired!Contact SNP Administrator",
          });
        }
      }).catch((error) => {
        console.log("a2z_login err ", error);
        setLoader(false);
        //window.location.href = "#/error";
        setErrResponse({
          error: true,
          errMsg: "Network Error,Please check your internet. Try again!",
        });
      });
  };

  // useEffect(() => {
  //   if (Object.keys(errors).length === 0 && isSubmit) {
  //     callback();           //navigate to other page
  //   }
  // }, [errors]);

  return { handleInputChange, values, handleSubmit, errors, errResponse };
};

export default useForm;
